import React from 'react';
import LandingPage from '../components/landing/LandingPage';

class Home extends React.Component {
  render() {
    return <LandingPage />;
  }
}

export default Home;
